import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MpathResultService {
  mpathResult: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mpath_result/list/?';
  private AddRecord = webapi + 'mpath_result/create';
  private EditTestResultReportRecord = webapi + 'mpath_result/edittestresultreport/';
  private EditRecord = webapi + 'mpath_result/update';
  private GetRecord = webapi + 'mpath_result/bybillidandtestid/';
  private GetRecordServiceAndTest = webapi + 'mpath_result/bybillidandtestid/';
  private DeleteRecord = webapi + 'mpath_result/delete/';
  private reportparamlist = webapi + 'mpath_result/listofpathreport?';
  private testResulReportUpload = webapi + 'mpath_result/uploadreport';
  private AddTestResultRecord = webapi + 'mpath_test_result/create';
  private EditTestResultRecord = webapi + 'mpath_test_result/editreport';
  private listOfReports = webapi + 'mpath_test_result/test_reports/';

  constructor(private http: Http) {
  }

  getReportParamByTrId(trId: any): Promise<any> {
    return this.http.get(this.reportparamlist + 'trId=' + trId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  testResulReportUploadService(model: any) {
    return this.http.post(this.testResulReportUpload, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addTestResultService(model: any) {
    //
    return this.http.post(this.AddTestResultRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editTestResultService(model: any): Promise<any> {
    return this.http.put(this.EditTestResultRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editTestResultReportService(model: any, psId: any): Promise<any> {
    // console.log('ps :', psId);
    return this.http.put(this.EditTestResultReportRecord + psId, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any): Promise<any> {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getListOfReport(psId: any): Promise<any> {
    return this.http.get(this.listOfReports + psId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordBillIdAndTest(billId: any, testId: any) {
    return this.http.get(this.GetRecordServiceAndTest + billId + '/' + testId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mpath-result/mpath-result.service.ts